import { useEffect, useState, type FormEvent } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

interface SearchBarProps {
  className?: string;
  onSubmitted?: () => void;
}

export default function SearchBar({ className = "", onSubmitted }: SearchBarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (location.pathname === "/search") {
      setValue(searchParams.get("q") ?? "");
    }
  }, [location.pathname, searchParams]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
    onSubmitted?.();
  };

  return (
    <form onSubmit={handleSubmit} className={`flex items-center gap-2 ${className}`}>
      <div className="relative flex-1">
        <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
        <input
          type="text"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="搜索你感兴趣的短视频"
          aria-label="搜索短视频"
          className="w-full rounded-full border border-background-300/70 bg-background-100 py-2 pl-9 pr-4 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:bg-background-50 focus:ring-2 focus:ring-primary-100"
        />
      </div>
      <button
        type="submit"
        className="shrink-0 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
      >
        搜索
      </button>
    </form>
  );
}